/**
 * Created by vsriram on 2/22/17.
 */
let instance = null;
class LocalStorageService {

  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }


  storeData(name, data) {
    var p = new Promise(function (resolve, reject) {
      resolve(localStorage.setItem(name, JSON.stringify(data)));
    });
    return p;
  }

  remove(name) {
    var p = new Promise(function (resolve, reject) {
      resolve(localStorage.removeItem(name));
    });
    return p;
  }

  fetchData(name) {
    var p = new Promise(function (resolve, reject) {
      var data = localStorage.getItem(name);
      if (data) {
        data = JSON.parse(data);
      }
      resolve(data);
    });
    return p;

  }

  fetchMultipleData(names) {
    var p = new Promise(function (resolve, reject) {
      const dataObject = {};
      names.map(function (name) {
        let data = localStorage.getItem(name);
        if (data) {
          data = JSON.parse(data);
          dataObject[name] = data;
        }
      });
      resolve(dataObject);
    });
    return p;

  }


}


export default LocalStorageService;